 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"CourseInvitationListPage":"CourseInvitationListPage","Message":"Message","PageNotFoundPage":"PageNotFoundPage","CourseNewRefundClaim~SingleCoursePage":"CourseNewRefundClaim~SingleCoursePage","CourseNewRefundClaim":"CourseNewRefundClaim","CourseListPage":"CourseListPage","SingleCoursePage":"SingleCoursePage","SingleAssignmentCoursePage":"SingleAssignmentCoursePage","ActiveAssignmentListPage":"ActiveAssignmentListPage","courseListPage":"courseListPage","Messages":"Messages"}[chunkId]||chunkId) + "." + {"CourseInvitationListPage":"7f802bf8","Message":"1dfb7fed","PageNotFoundPage":"cce77c1c","chunk-2d0c8d1a":"536119f4","chunk-2e2f13c8":"a3f632c1","chunk-6e83591c":"22ec3898","chunk-43d6f666":"352a6459","CourseNewRefundClaim~SingleCoursePage":"523cebd0","CourseNewRefundClaim":"54fd1242","chunk-41c304bc":"91b616b2","chunk-f7aea834":"917b270c","chunk-2a45c974":"fd58345f","chunk-7c42968a":"20e032a5","chunk-72cb6c98":"715f299d","chunk-7743b166":"114dd3ce","chunk-79b3301a":"366a12ed","chunk-7c3b01bf":"eb54bc2e","chunk-d3b67c60":"d9f2bb20","CourseListPage":"2b5d8d45","chunk-0f241187":"f05ecca2","chunk-fecf8b82":"e51c25f0","SingleCoursePage":"e8d52298","SingleAssignmentCoursePage":"c38a280e","chunk-7666dcc8":"713e6ddc","chunk-df3cc48a":"4fba43a2","ActiveAssignmentListPage":"b3a73c90","chunk-b45d856c":"b5f5620b","chunk-b4833a4a":"223cca3d","chunk-b4876046":"c1a770c2","courseListPage":"64a53516","chunk-ebbab3dc":"802cd3a1","Messages":"3c0e41c3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"CourseInvitationListPage":1,"Message":1,"chunk-2e2f13c8":1,"chunk-43d6f666":1,"CourseNewRefundClaim~SingleCoursePage":1,"CourseNewRefundClaim":1,"chunk-41c304bc":1,"chunk-f7aea834":1,"chunk-2a45c974":1,"chunk-7c42968a":1,"chunk-72cb6c98":1,"chunk-7743b166":1,"chunk-79b3301a":1,"chunk-7c3b01bf":1,"chunk-d3b67c60":1,"CourseListPage":1,"chunk-fecf8b82":1,"SingleCoursePage":1,"SingleAssignmentCoursePage":1,"chunk-7666dcc8":1,"chunk-ebbab3dc":1,"Messages":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"CourseInvitationListPage":"CourseInvitationListPage","Message":"Message","PageNotFoundPage":"PageNotFoundPage","CourseNewRefundClaim~SingleCoursePage":"CourseNewRefundClaim~SingleCoursePage","CourseNewRefundClaim":"CourseNewRefundClaim","CourseListPage":"CourseListPage","SingleCoursePage":"SingleCoursePage","SingleAssignmentCoursePage":"SingleAssignmentCoursePage","ActiveAssignmentListPage":"ActiveAssignmentListPage","courseListPage":"courseListPage","Messages":"Messages"}[chunkId]||chunkId) + "." + {"CourseInvitationListPage":"5fc8bfb3","Message":"f5a68b12","PageNotFoundPage":"31d6cfe0","chunk-2d0c8d1a":"31d6cfe0","chunk-2e2f13c8":"069ba2b1","chunk-6e83591c":"31d6cfe0","chunk-43d6f666":"49830f27","CourseNewRefundClaim~SingleCoursePage":"f7ec7090","CourseNewRefundClaim":"ba7b7671","chunk-41c304bc":"d44cb5ac","chunk-f7aea834":"5d0fe94e","chunk-2a45c974":"7996268a","chunk-7c42968a":"2b44a26a","chunk-72cb6c98":"22e74c12","chunk-7743b166":"22e74c12","chunk-79b3301a":"22e74c12","chunk-7c3b01bf":"22e74c12","chunk-d3b67c60":"68e283e9","CourseListPage":"65d78760","chunk-0f241187":"31d6cfe0","chunk-fecf8b82":"e79726c3","SingleCoursePage":"551d6e56","SingleAssignmentCoursePage":"3ef20b1f","chunk-7666dcc8":"83ec76d9","chunk-df3cc48a":"31d6cfe0","ActiveAssignmentListPage":"31d6cfe0","chunk-b45d856c":"31d6cfe0","chunk-b4833a4a":"31d6cfe0","chunk-b4876046":"31d6cfe0","courseListPage":"31d6cfe0","chunk-ebbab3dc":"ad88e263","Messages":"63a5a00e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
